import React, { useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { TextField, InputAdornment } from '@mui/material';
import { PersonOutline, Lock } from '@mui/icons-material';
import { useFormik } from 'formik';
import { Redirect, useHistory } from 'react-router-dom';
import Button from 'components/Button';

import { IStore } from 'store/reducers';
import { useDispatch, useSelector } from 'react-redux';

import { loginAgencyRequest, setLoading, logoutAgency } from 'store/actions';
import { AppViews } from 'endpoints';

import { AppToast } from 'components/toast';
import { useTranslation } from 'react-i18next';
import { ContentLogin, BoxLogin, BoxInput, Title } from './styles';
import { validationSchema } from './validationSchema';

const Login = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { token }: any = useSelector<IStore>((state) => state.authAgency);
  const { t } = useTranslation();

  useEffect(() => {
    dispatch(logoutAgency());
  }, []);

  const formik = useFormik({
    initialValues: {
      userName: '',
      password: '',
    },
    validationSchema,
    onSubmit: async ({ userName, password }) => {
      dispatch(setLoading(true));
      try {
        const res = await dispatch(loginAgencyRequest.request({ userName, password }));
        dispatch(setLoading(false));
        if (res.token) {
          window.location.href = AppViews.HOME;
        } else {
          AppToast.error(t('validations:somethingWentWrong'));
        }
      } catch (err) {
        AppToast.error('Usuário ou senha inválido');
        dispatch(setLoading(false));
      }
    },
  });

  return (
    <Container>
      <Row>
        <Col>
          <ContentLogin>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                formik.handleSubmit();
              }}
            >
              <BoxLogin>
                <Title>Iniciar sessão</Title>
                <BoxInput>
                  <TextField
                    name="userName"
                    label="Username"
                    value={formik.values.userName}
                    fullWidth
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.userName && Boolean(formik.errors.userName)}
                    helperText={formik.touched.userName && formik.errors.userName}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <PersonOutline style={{ color: '#F8AE1B' }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </BoxInput>
                <BoxInput>
                  <TextField
                    name="password"
                    label="Password"
                    value={formik.values.password}
                    fullWidth
                    type="password"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.password && Boolean(formik.errors.password)}
                    helperText={formik.touched.password && formik.errors.password}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Lock style={{ color: '#F8AE1B' }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </BoxInput>
                <Button type="submit" onClick={() => formik.handleSubmit()}>
                  Acessar
                </Button>
              </BoxLogin>
            </form>
          </ContentLogin>
        </Col>
      </Row>
    </Container>
  );
};

export default Login;
